import { Routes } from '@angular/router';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { GetNumberComponent } from './get-number.component';
import { PricingNumbersResolve } from './pricing-numbers/pricing-numbers.resolve';
import { PricingNumbersComponent } from './pricing-numbers/pricing-numbers.component';
import { ChooseNumberComponent } from './pricing-numbers/choose-number/choose-number.component';
import { GetNumberFinalStepComponent } from './get-number-final-step/get-number-final-step.component';
import { SinglePricingResolve } from './pricing-numbers/single-pricing.resolve';
import { FirstNumberWelcomeComponent } from './first-number-welcome/first-number-welcome.component';

const getNumberChildrenRoutes = [
  {
    path: '',
    redirectTo: 'pricing',
    pathMatch: 'full'
  },
  {
    path: 'pricing',
    component: PricingNumbersComponent
  },
  {
    path: 'pricing/:code',
    component: PricingNumbersComponent,
    resolve: {
      pricingNumbers: PricingNumbersResolve
    }
  },
  {
    path: 'numbers/:pricingId',
    component: ChooseNumberComponent
  },
  {
    path: 'pricing/:pricingId/final-step',
    component: GetNumberFinalStepComponent,
    resolve: {
      pricing: SinglePricingResolve
    }
  }
];

export const getNumberRoutes: Routes = [
  {
    path: 'get-new-number',
    component: GetNumberComponent,
    canActivate: [Ng1LoadedGuard],
    children: getNumberChildrenRoutes
  },
  {
    path: 'get-first-new-number',
    component: GetNumberComponent,
    canActivate: [Ng1LoadedGuard],
    children: getNumberChildrenRoutes
  },
  {
    path: 'welcome',
    component: FirstNumberWelcomeComponent,
    canActivate: [Ng1LoadedGuard]
  }
];
